/**
 * Google sign-in + cloud-save configuration.
 *
 * ─ HOW TO TURN SIGN-IN ON ───────────────────────────────────────────────────
 *  1. Google Cloud Console → APIs & Services → Credentials → "Create
 *     credentials" → "OAuth client ID" → type "Web application".
 *  2. Authorized JavaScript origins: add
 *       https://nodus.hayterwave.com
 *       https://nodus-evs.pages.dev
 *       http://localhost:5173     (local dev)
 *  3. Copy the generated client id (looks like
 *     `1234567890-abc...apps.googleusercontent.com`) into GOOGLE_CLIENT_ID
 *     below, AND set the SAME value on the worker:
 *       cd ../nodus-sync && wrangler deploy   (after putting it in wrangler.jsonc vars)
 *  4. Rebuild + redeploy Nødus.
 *
 * EMPTY string = sign-in is dark: the menu shows no sign-in button and the
 * cloud layer is a no-op. Client ids are public, so this is safe to commit.
 */
export const GOOGLE_CLIENT_ID = '';

/** Base URL of the nodus-sync worker (set after `wrangler deploy` prints it). */
export const SYNC_API_URL = 'https://nodus-sync.hayterfinance.workers.dev';

/** True once both halves of the seam are configured. */
export const authConfigured = (): boolean => GOOGLE_CLIENT_ID.length > 0 && SYNC_API_URL.length > 0;
